var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutiveDashboards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15v5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20h6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11v-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11v-5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11v-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveDashboards);
export default __webpack_public_path__ + "static/media/ExecutiveDashboards.bb6f7af2da5cae16511a6e92e2e4421e.svg";
export { ForwardRef as ReactComponent };